import { render, staticRenderFns } from "./NominasForm.vue?vue&type=template&id=81b358c4&"
import script from "./NominasForm.vue?vue&type=script&lang=js&"
export * from "./NominasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports